'use strict';

/**
 * @ngdoc Class
 * @name mx.SolutionBuilderAgent.SelectionViewLocals
 *
 * @description
 * Input attributes for controller of SelectionView
 *
 * @param {Object} options - display name of the selection view
 *
 */
export default class SelectionViewLocals {
	constructor(options) {
		let title,
			entityClassName,
			relation,
			archived,
			multiSelection,
			allowedTypes,
			filter,
			correctEntityFilter,
			columnDefinition,
			onlyTypedSelectSearch,
			context,
			objectIDs,
			excludedIDs,
			viewMode,
			createButtonHidden,
			allowResetFilter,
			resetFilterExpression;

		Object.defineProperty(this, 'title', {
			enumerable: true,
			set: function (newValue) {
				title = newValue || '';
			},
			get: function () {
				return title;
			},
		});

		Object.defineProperty(this, 'multiSelection', {
			enumerable: true,
			set: function (newValue) {
				multiSelection = Boolean(newValue);
			},
			get: function () {
				return multiSelection;
			},
		});

		Object.defineProperty(this, 'entityClassName', {
			enumerable: true,
			set: function (newValue) {
				entityClassName = newValue;
			},
			get: function () {
				return entityClassName;
			},
		});

		Object.defineProperty(this, 'relation', {
			enumerable: true,
			set: function (newValue) {
				relation = newValue;
			},
			get: function () {
				return relation;
			},
		});

		Object.defineProperty(this, 'archived', {
			enumerable: true,
			set: function (newValue) {
				archived = newValue;
			},
			get: function () {
				return archived;
			},
		});

		Object.defineProperty(this, 'objectIDs', {
			enumerable: true,
			set: function (newValue) {
				objectIDs = Array.isArray(newValue) ? newValue : [];
			},
			get: function () {
				return objectIDs;
			},
		});

		Object.defineProperty(this, 'excludedIDs', {
			enumerable: true,
			set: function (newValue) {
				excludedIDs = Array.isArray(newValue) ? newValue : [];
			},
			get: function () {
				return excludedIDs;
			},
		});

		Object.defineProperty(this, 'allowedTypes', {
			enumerable: true,
			set: function (newValue) {
				allowedTypes = newValue;
			},
			get: function () {
				return allowedTypes;
			},
		});

		Object.defineProperty(this, 'filter', {
			enumerable: true,
			set: function (newValue) {
				filter = newValue;
			},
			get: function () {
				return filter;
			},
		});

		Object.defineProperty(this, 'correctEntityFilter', {
			enumerable: true,
			set: function (newValue) {
				correctEntityFilter = newValue;
			},
			get: function () {
				return correctEntityFilter;
			},
		});

		Object.defineProperty(this, 'columnDefinition', {
			enumerable: true,
			set: function (newValue) {
				columnDefinition = newValue;
			},
			get: function () {
				return columnDefinition;
			},
		});

		Object.defineProperty(this, 'onlyTypedSelectSearch', {
			enumerable: true,
			set: function (newValue) {
				onlyTypedSelectSearch = newValue;
			},
			get: function () {
				return onlyTypedSelectSearch;
			},
		});

		Object.defineProperty(this, 'allowResetFilter', {
			enumerable: true,
			set: function (newValue) {
				allowResetFilter = Boolean(newValue);
			},
			get: function () {
				return allowResetFilter;
			},
		});

		Object.defineProperty(this, 'resetFilterExpression', {
			enumerable: true,
			set: function (newValue) {
				resetFilterExpression = newValue;
			},
			get: function () {
				return resetFilterExpression;
			},
		});

		Object.defineProperty(this, 'context', {
			enumerable: true,
			set: function (newValue) {
				context = newValue;
			},
			get: function () {
				return context;
			},
		});

		Object.defineProperty(this, 'viewMode', {
			enumerable: true,
			set: function (newValue) {
				viewMode = Boolean(newValue);
			},
			get: function () {
				return viewMode;
			},
		});

		Object.defineProperty(this, 'createButtonHidden', {
			enumerable: true,
			set: function (newValue) {
				createButtonHidden = Boolean(newValue);
			},
			get: function () {
				return createButtonHidden;
			},
		});

		angular.extend(this, options);
	}
}
